if (!window.__montemGalleryInit) {
  window.__montemGalleryInit = true;
 
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-montem-add]');
    if (!btn) return;
    e.preventDefault();
 
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId || btn.disabled) return;
 
    var original = btn.textContent;
    btn.disabled = true;
 
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (res) {
        if (!res.ok) { return res.json().then(function (e) { throw new Error(e.description || 'add failed'); }); }
        return res.json();
      })
      .then(function () {
        btn.textContent = '\u2713';
        document.dispatchEvent(new CustomEvent('montem:cart:updated'));
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1400);
      })
      .catch(function () {
        btn.textContent = '!';
        setTimeout(function () {
          btn.textContent = original;
          btn.disabled = false;
        }, 1400);
      });
  });
}